import { useEffect, useState } from 'react';
import { useNavigation } from 'react-router-dom';
import { LogoSpinner } from './LogoSpinner';

/** Fast page loads finish before the overlay would only flash. */
const SHOW_AFTER_MS = 150;

/**
 * While the next page loads (its code chunk): a translucent backdrop over
 * the current page with a spinner in the middle of the screen, so a click
 * on a menu item is visibly taken and the old page cannot be clicked.
 * Place it in a `relative` container (the content area).
 */
export function NavigationProgress() {
	const loading = useNavigation().state === 'loading';
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		if (!loading) return;
		const timer = window.setTimeout(() => setVisible(true), SHOW_AFTER_MS);
		return () => {
			window.clearTimeout(timer);
			setVisible(false);
		};
	}, [loading]);

	if (!loading) return null;

	return (
		// Blocks clicks at once; shows itself only after the delay.
		<div
			className="absolute inset-0 z-30"
			aria-hidden={visible ? undefined : true}
		>
			{visible && (
				<div className="bg-background/60 animate-in fade-in absolute inset-0 backdrop-blur-[1px] duration-200 motion-reduce:animate-none">
					{/* Sticky below the header (h-16): mid-screen on a long page. */}
					<div className="sticky top-16 flex h-[calc(100dvh-4rem)] max-h-full items-center justify-center">
						<div
							role="status"
							aria-label="Loading page"
							className="bg-background rounded-full p-1.5 shadow-md"
						>
							<LogoSpinner />
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
